<template>
  <el-dialog
      :visible.sync="createDialogOpen"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="rejection-modal"
      @close="onDialogClose"
      title="Форма добавления"
  >
    <template slot="default">
      <el-form :model="form" :rules="form_rules" ref="AddUserForm">
        <el-form-item label="Русский" prop="name_ru">
          <el-input type="textarea" rows="5" v-model="form.name_ru"></el-input>
        </el-form-item>
        <el-form-item label="Казахский" prop="name_kz">
          <el-input type="textarea" rows="5" v-model="form.name_kz"></el-input>
        </el-form-item>
        <el-form-item label="Английский" prop="name_en">
          <el-input type="textarea" rows="5" v-model="form.name_en"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template slot="footer">
      <button class="btn" @click="save">Сохранить</button>
      <button class="btn" @click="close">Отмена</button>
    </template>
  </el-dialog>
</template>
<script>
import {mapState} from 'vuex'
import {actionTypes as formSettingsActionTypes} from '@/store/modules/formSettings'
import formSettings from '@/mixins/formSettings'

export default {
  mixins: [formSettings],
  data(){
    return {
      form: {
        name_ru: '',
        name_kz: '',
        name_en: ''
      },
      form_rules: {
        name_ru: [
          { required: true, message: 'Введите русский текст', trigger: 'blur' }
        ],
        name_kz: [
          { required: true, message: 'Введите казахский текст', trigger: 'blur' }
        ],
        name_en: [
          { required: true, message: 'Введите английский текст', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    save(){
      this.$store.dispatch(formSettingsActionTypes.addItem, this.form)
          .then(() => {
            this.$message({message: 'Новый пункт добавлен', type: 'success'})
            this.createDialogOpen = false
          })
    },
    close(){
      this.createDialogOpen = false
    },
    onDialogClose(){
      this.form = {
        name_ru: '',
        name_kz: '',
        name_en: ''
      }
    }
  }
}
</script>